import { useState } from 'react';
import { BaseItem } from './base-item';

export interface MultiLabelItemProps {
  id: string;
  image: string;
  title: string;
  labels: string[];
  hideLabel?: boolean;
  overrideLabel?: string | null;
  onToggle?: (obtained: boolean) => void;
}

export function MultiLabelItem(props: MultiLabelItemProps) {
  const [isObtained, setIsObtained] = useState(false);
  const [labelIndex, setLabelIndex] = useState(0);

  const handleClick = () => {
    const next = !isObtained;
    setIsObtained(next);
    props.onToggle?.(next);
  };

  const handleRightClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const next = !isObtained;
    setIsObtained(next);
    props.onToggle?.(next);
  };

  const handleWheel = (e: React.WheelEvent) => {
    if (e.deltaY > 0) {
      setLabelIndex((prev) => (prev === 0 ? props.labels.length - 1 : prev - 1));
    } else {
      setLabelIndex((prev) => (prev === props.labels.length - 1 ? 0 : prev + 1));
    }
  };

  return (
    <div
      className="relative w-9 flex flex-col items-center justify-center"
      onWheel={handleWheel}
    >
      <BaseItem
        id={props.id}
        image={props.image}
        title={props.title}
        isObtained={isObtained}
        onClick={handleClick}
        onRightClick={handleRightClick}
      />
      {!props.hideLabel && (
        <span
          className="text-xs font-bold select-none cursor-pointer text-center
            [text-shadow:1px_1px_2px_black,0_0_8px_rgba(0,0,255,0.6)]"
          onClick={handleClick}
          onContextMenu={handleRightClick}
        >
          {props.overrideLabel || props.labels[labelIndex]}
        </span>
      )}
    </div>
  );
}
